var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.238 9.05 12 6.25H9.333v-1.4c0-.721 0-1.4 1.524-1.4H12V1.098A23.34 23.34 0 0 0 9.823 1C7.755 1 6.286 2.16 6.286 4.29v1.96H4v2.8h2.286V15h3.047V9.05h1.905Z"
  })));
};

export default SvgFacebook;